import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import moment from 'moment';
import 'moment-timezone';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['../../rendered.component.scss', './time-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimePickerComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() change = new EventEmitter<any>();
  date;
  momentDate;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  private _displayDate: moment.Moment;
  set displayDate(v: moment.Moment) {
    console.log(v);
    this._displayDate = v;
    this.setDateTime();
  }
  get displayDate(): moment.Moment {
    return this._displayDate;
  }
  timezone = null;
  local;

  constructor(
    public cdr: ChangeDetectorRef,
    private viewUpdate: ViewUpdateService,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    if (this.item.data && Array.isArray(this.item.data)) {
      for (let i = 0; i < this.item.data.length; i++) {
        const dataItem = this.item.data[i];
        if (dataItem.name && dataItem.name.indexOf('timezone') !== -1) {
          this.timezone = dataItem.value;
        }
      }
    }

    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(e => {
        this.update();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  /**
   * Convert time stampe to local or course time
   * */
  calcTime() {
    // if the date is set
    if (this.date) {
      console.log(this.date);
      // convert stored UTC string to moment date
      this.momentDate = moment.utc(this.date);
      console.log(this.momentDate.format('MM DD YYYY LT'));
      let date = this.momentDate;
      // if the course timezone is set
      if (this.timezone) {
        console.log('setting timezone', this.timezone);
        // convert utc string to moment in the correct timezone
        date = moment.utc(this.date).tz(this.timezone);
      }
      console.log(date.format('MM DD YYYY LT'));
      // convert time to local moment with the same time value so it can be displayed in HTML
      const local = moment(date.format('MM DD YYYY LT'), 'MM DD YYYY LT');
      if (!this.displayDate) {
        this._displayDate = local;
      }
    } else {
      this._displayDate = undefined;
    }
  }
  /**
   *Event for getting a date change in the input
   * */
  setDateTime() {
    console.log(this.displayDate);
    this.date = this.displayDate;
    if (this.displayDate) {
      // create moment from set date
      const date = moment(this.displayDate);
      // if a timezone is set
      if (this.timezone) {
        console.log(date.format('MMM DD YYYY LT'));
        // convert date to the correct timezone
        this.momentDate = moment.tz(
          date.format('MM DD YYYY LT'),
          'MM DD YYYY LT',
          this.timezone
        );
      } else {
        this.momentDate = date;
      }
      console.log(this.momentDate);
      // generate the utc to store in the database from the correct timezone
      const utc = this.momentDate.utc();
      console.log(utc.format());
      this.change.emit({ value: utc.format() });
    } else {
      this.change.emit({ value: null });
    }
  }

  update() {
    console.log('UPDATING DATE');
    this.date = this.value;
    if (this.item.data && Array.isArray(this.item.data)) {
      for (let i = 0; i < this.item.data.length; i++) {
        const dataItem = this.item.data[i];
        if (dataItem.name && dataItem.name.indexOf('timezone') !== -1) {
          this.timezone = dataItem.value;
        }
      }
    }
    this.calcTime();
    if (this.data) {
      const dataKeys = Object.keys(this.data);

      if (this.item.data && Array.isArray(this.item.data)) {
        for (let i = 0; i < this.item.data.length; i++) {
          const dataItem = this.item.data[i];

          for (let j = 0; j < dataKeys.length; j++) {
            if (dataItem.name === dataKeys[j]) {
              const newTimezone = this.data[dataKeys[j]];
              if (this.timezone !== newTimezone) {
                this.timezone = newTimezone;
                this.calcTime();
              }
            }
          }
        }
      }
    }
    this.cdr.detectChanges();
  }

  dateChanged(event, data, key) {
    setTimeout(() => {
      this.item.value = key;
      console.log(event);
      data[key] = event;
    });
  }
}
